import { MapUiTheme } from '../../common';
import { padding } from '../../common/theme/utils';

export const notificationsTheme = {
  container: {
    boxSizing: 'border-box',
    position: 'fixed',
    zIndex: (theme: MapUiTheme) => theme.zIndices.toast,
    padding: (theme: MapUiTheme) => padding(0, theme.spacing[4]),
    maxHeight: (theme: MapUiTheme) => `calc(100vh - ${theme.spacing[8]})`,
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  position: {
    left: {
      top: (theme: MapUiTheme) => theme.spacing[4],
      left: (theme: MapUiTheme) => theme.spacing[6],
      textAlign: 'left',
    },
    middle: {
      top: (theme: MapUiTheme) => theme.spacing[4],
      left: '50%',
      transform: 'translateX(-50%)',
      textAlign: 'center',
    },
    right: {
      top: (theme: MapUiTheme) => theme.spacing[4],
      right: (theme: MapUiTheme) => theme.spacing[6],
      textAlign: 'right',
    },
  },
  notification: {
    defaultStyles: {
      display: 'inline-block',
      textAlign: 'initial',
      minWidth: '320px',
      width: 'auto',
      maxWidth: '40vw',
      position: 'relative',
      borderRadius: (theme: MapUiTheme) => theme.borderRadius.lg,
      background: (theme: MapUiTheme) => theme.colors.black,
      color: (theme: MapUiTheme) => theme.colors.white,
      lineHeight: (theme: MapUiTheme) => theme.lineHeight.normal,
      boxShadow: (theme: MapUiTheme) => theme.boxShadow.lg,
      ...padding(
        (theme: MapUiTheme) => theme.spacing['4'],
        (theme: MapUiTheme) => theme.spacing['4']
      ),
    },
    info: {
      background: (theme: MapUiTheme) => theme.colors.interaction200,
      color: (theme: MapUiTheme) => theme.colors.white,
      border: 'none',
    },
    warning: {
      background: (theme: MapUiTheme) => theme.colors.warning300,
      color: (theme: MapUiTheme) => theme.colors.white,
      border: 'none',
    },
    success: {
      background: (theme: MapUiTheme) => theme.colors.success300,
      color: (theme: MapUiTheme) => theme.colors.white,
      border: 'none',
    },
    error: {
      background: (theme: MapUiTheme) => theme.colors.danger300,
      color: (theme: MapUiTheme) => theme.colors.white,
      border: 'none',
    },
  },
};
